import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { card, text, Space } from 'components/common';
import { useTranslation } from 'react-i18next';
import ROUTES from 'utils/constants/routes.json';
import { PrimaryButton } from 'components/common/button';

const { LogoCard } = card;
const { Title } = text;

const Container = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .space {
        width: 100%;
        text-align: center;

        button {
            margin-top: 10px;

            width: fit-content;
        }
    }
`;

const ContactSubmittedView: React.FC = () => {
    const { t } = useTranslation(['common']);
    return (
        <Container className="container">
            <LogoCard>
                <Space alignItems="center" direction="column">
                    <Title level={3}>{t('common:contact_success')}</Title>
                    <Link to={ROUTES.base}>
                        <PrimaryButton>{t('common:return')}</PrimaryButton>
                    </Link>
                </Space>
            </LogoCard>
        </Container>
    );
};

export default ContactSubmittedView;
